module.exports = __webpack_public_path__ + "img/oyster.5476abef.png";